<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />
    <filter-manager
      :display-advanced="false"
      class="search-bar"
      search-icon="fa fa-sync"
      search-text="Procesar"
      search-container-class="btn-process"
      v-model="model.search.filters"
      :filters="filterManagerConfig"
      @search="process"
      ref="filterRef"
    />
    <custom-separator class="mt-1 mb-4" text="Resultado de Referido" />

    <custom-result-not-found :text="'No hay información disponible.'" />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import LocationServices from '@/services/api/locationService.api';
import SpecialistServices from '@/services/api/specialist.api';
import AcademicYearServices from '@/services/api/academicyear.api';
import serviceType from '@/utils/constants/serviceType';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';

export default {
  name: 'SpecialistCalendarReport',
  components: {
    PageHeader,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
  },
  data: () => ({
    model: {
      search: {
        collections: {
          providers: [],
          municipalities: [],
          servicePlaces: [],
          diciplineTypes: [],
          specialists: [],
        },
        filters: {
          academicYear: null,
          provider: null,
          municipality: null,
          servicePlace: null,
          diciplineType: null,
          specialist: null,
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Informe de Calendario de Especialista',
        icon: 'fas fa-file-invoice pr-0 font-22 magnifying-glass-icon-m ',
        routes: ['Inicio', 'Informes Generales', ' Informe de Ausencia'],
      };
    },
    filterManagerConfig() {
      return [
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Proveedor',
          error: 'El proveedor es requerido.',
          validations: 'required',
          class: 'col-12 col-md-3',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          onChanged: this.getProviderMunicipalities,
          clearModelsOnUpdate: [
            'municipality',
            'servicePlace',
            'diciplineType',
            'specialist',
          ],
          disabled: this.model.search.collections.providers.length == 1,
        },
        {
          name: 'municipality',
          component: 'custom-drop-down',
          error: 'El Municipio es requerido.',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Municipio',
          options: this.model.search.collections.municipalities,
          value: this.model.search.filters.municipality,
          class: 'col-12 col-md-2',
          validations: 'required',
          onChanged: this.getServiceLocations,
          clearModelsOnUpdate: ['servicePlace', 'diciplineType', 'specialist'],
          disabled: this.model.search.collections.municipalities.length == 1,
        },
        {
          name: 'servicePlace',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Lugar de Servicio',
          options: this.model.search.collections.servicePlaces,
          value: this.model.search.filters.servicePlace,
          class: 'col-12 col-md-3',
          validations: null,
          onChanged: this.getDisciplinesList,
          clearModelsOnUpdate: ['diciplineType', 'specialist'],
          disabled: this.model.search.collections.servicePlaces.length == 1,
        },
        {
          name: 'diciplineType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Disciplina',
          options: this.model.search.collections.diciplineTypes,
          value: this.model.search.filters.diciplineType,
          class: 'col-12 col-md-2',
          validations: null,
          onChanged: this.getSpecialist,
          clearModelsOnUpdate: ['specialist'],
          disabled: this.model.search.collections.diciplineTypes.length == 1,
        },
        {
          name: 'specialist',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Especialista',
          options: this.model.search.collections.specialists,
          value: this.model.search.filters.specialist,
          class: 'col-12 col-md-2',
          validations: null,
          disabled: this.model.search.collections.specialists.length == 1,
        },
      ];
    },
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async getCurrentAcademicYear() {
      const {
        data: currentAcademicYear,
      } = await AcademicYearServices.getCurrentAcademicYear();
      this.model.search.filters.academicYear = currentAcademicYear;
      await this.getCompaniesWithContracts();
    },
    async getCompaniesWithContracts() {
      const { data } = await SpecialistServices.getCompaniesWithContracts(
        this.model.search.filters.academicYear?.id
      );
      this.model.search.collections.providers = data;

      if (this.model.search.collections.providers.length == 1) {
        this.model.search.filters.provider = this.model.search.collections.providers[0];
        this.getProviderMunicipalities();
      }
    },
    async getServiceLocations() {
      const params = {
        municipalityId: this.model.search.filters.municipality?.id,
      };
      const { data } = await LocationServices.getServiceLocations(
        this.model.search.filters.provider?.id,
        params
      );
      this.model.search.collections.servicePlaces = data;

      if (this.model.search.collections.servicePlaces.length == 1) {
        this.model.search.filters.servicePlace = this.model.search.collections.servicePlaces[0];
        this.getDisciplinesList();
      }
    },
    async getDisciplinesList() {
      const { data } = await LocationServices.getDisciplinesList(
        this.model.search.filters.provider?.id,
        this.model.search.filters.servicePlace?.id,
        serviceType.Therapy
      );

      this.model.search.collections.diciplineTypes = data;

      if (this.model.search.collections.diciplineTypes.length == 1) {
        this.model.search.filters.diciplineType = this.model.search.collections.diciplineTypes[0];
        this.getSpecialist();
      }
    },
    async getProviderMunicipalities() {
      const { data } = await SpecialistServices.getProviderMunicipalities(
        this.model.search.filters.provider?.id
      );

      this.model.search.collections.municipalities = data;

      if (this.model.search.collections.municipalities.length == 1) {
        this.model.search.filters.municipality = this.model.search.collections.municipalities[0];
        this.getServiceLocations();
      }
    },
    async getSpecialist() {
      const { data } = await SpecialistServices.specialistsList(
        this.model.search.filters.provider?.id,
        this.model.search.filters.servicePlace?.id,
        this.model.search.filters.diciplineType?.id
      );

      this.model.search.collections.specialists = data;

      if (this.model.search.collections.specialists.length == 1)
        this.model.search.filters.specialist = this.model.search.collections.specialists[0];
    },
    async setFilters() {
      await this.getCurrentAcademicYear();
    },
    async process() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }
      
      await ReportServices.getReport('specialistavailabilitycalendar', {
        providerId: this.model.search.filters.provider?.id,
        municipalityId: this.model.search.filters.municipality?.id,
        locationId: this.model.search.filters.servicePlace?.id,
        disciplineId: this.model.search.filters.diciplineType?.id,
        specialistId: this.model.search.filters.specialist?.id,
      }).then((res) => DocumentServices.Download(res.data));
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .btn-process {
  bottom: -1px !important;
  right: 15px !important;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}
</style>
